import React, { useRef, useState } from "react";
import { useFocusable } from "@noriginmedia/norigin-spatial-navigation";
import { useEvents } from "../context/EventsContext";
import { isContentNowPlaying } from "../utils/shared/eventStatus";
import { CONTENT_TYPE } from "../constants/event";
import { getModelConfig } from "../../utils/models";
import { scrollIntoViewWithinContainer } from "../utils/shared/scrollIntoView";
import playIcon from "../../assets/playNowIcon.svg";
import removeIcon from "../../assets/removeEvent.svg";
import Loader from "./Loader";
import "./Button.scss";
import "../epg.scss";

const ChannelBanner = ({ channelData, onWatchNow }) => {
    const { activeLiveContent } = useEvents();
    const [isLoading, setIsLoading] = useState(false);

    const isSubscribed = isContentNowPlaying(
        { id: channelData.channelId, contentType: CONTENT_TYPE.LIVE_CHANNEL },
        activeLiveContent
    );

    const btnIcon = isSubscribed ? removeIcon : playIcon;
    const btnText = isSubscribed ? "Remove Channel" : "Watch Now";
    const bgColor = isSubscribed || isLoading ? "rgba(255, 255, 255, 0.32)" : "#fff";
    const textColor = isSubscribed || isLoading ? "#fff" : "#000";

    const handlePress = async () => {
        setIsLoading(true);
        await onWatchNow(channelData);
        setIsLoading(false);
    };

    const bannerRef = useRef(null);

    const { ref, focused } = useFocusable({
        focusKey: "CHANNEL_BANNER_WATCH_NOW",
        onEnterPress: handlePress,
        // Scroll the entire banner into view (not just the button) when focus returns from the event grid
        onFocus: () => {
            const bannerEl = bannerRef.current;
            if (bannerEl) {
                if (getModelConfig().epg.customScrollBehavior) {
                    scrollIntoViewWithinContainer(bannerEl, 'scrollingRows');
                } else {
                    bannerEl.scrollIntoView({
                        behavior: getModelConfig().epg.scrollBehavior,
                        block: "nearest",
                        inline: "nearest",
                    });
                }
            }
        },
    });

    return (
        <div
            ref={bannerRef}
            className="channelBanner"
            style={channelData.bannerUrl ? { backgroundImage: `url(${channelData.bannerUrl})` } : {}}
        >
            <div className="channelBannerOverlay">
                <div className="channelBannerInfo">
                    <h2 className="channelBannerName">{channelData.channelName}</h2>
                    <button
                        ref={ref}
                        className={`button channelBannerBtn ${focused ? "focused" : ""}`}
                        style={{ backgroundColor: bgColor }}
                    >
                        {isLoading && <Loader textColor={textColor} />}
                        {!isLoading && (
                            <span className="icon">
                                <img src={btnIcon} alt="" />
                            </span>
                        )}
                        <span className="text" style={{ color: textColor }}>
                            {btnText}
                        </span>
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ChannelBanner;
